import { combineReducers } from "@reduxjs/toolkit";

import { KnowledgeRepositoryReducer } from "./KnowledgeRepositoryReducer";
import { LoadingReducer } from "./LoadingReducer";
import { CollaborationReducer } from "./CollaborationReducer";
import { ResearchReducer } from "./ResearchReducer";
import { ProjectReducer } from "./ProjectReducer";
import { TeamReducer } from "./TeamReducer";
import { EventReducer } from "./EventReducer";
import { AnnouncementReducer } from "./AnnouncementReducer";
import { VacanciesReducer } from "./VacanciesReducer";
import { BannerReducer } from "./BannerReducer";

export default combineReducers({
    LoadingReducer,
    KnowledgeRepositoryReducer,
    CollaborationReducer,
    ResearchReducer,
    ProjectReducer,
    TeamReducer,
    EventReducer,
    AnnouncementReducer,
    VacanciesReducer,
    BannerReducer,
});